import { z } from 'zod';

export const pictureUploadUrlDTOSchema = z.object({
  uploadUrl: z.string(),
  pictureUrl: z.string(),
});

export const pictureUploadUrlInputDTOSchema = z.object({
  type: z.enum([
    'image/png',
    'image/jpeg',
    'image/webp',
    'image/avif',
    'image/gif',
    'image/svg+xml',
  ]),
  contentLength: z
    .number()
    .positive()
    .max(5 * 1024 * 1024), // 5 MB
});
